import { Environment, OrbitControls, useTexture } from "@react-three/drei";
import { useThree } from "@react-three/fiber";
import { useMemo } from "react";
import { Avatar } from "./Avatar";

export const Experience = (props) => {
  const viewport = useThree((state) => state.viewport);
  
  // Use the background image passed as prop, or fallback to random selection
  const backgroundImage = props.backgroundImage || (() => {
    // Fallback: List of available background images
    const backgroundImages = [
      "/textures/bg-1.jpg",
      "/textures/bg-2.jpg",
      "/textures/bg-3.jpg",
      "/textures/bg-4.jpg",
      "/textures/bg-5.jpg",
      "/textures/bg-6.jpg",
      "/textures/bg-7.jpg",
      "/textures/bg-9.jpg",
      "/textures/bg-10.jpg",
      "/textures/bg-11.jpg",
      "/textures/bg-12.jpg",
    ];
    // Randomly select a background image if no prop provided
    const randomIndex = Math.floor(Math.random() * backgroundImages.length);
    return backgroundImages[randomIndex];
  })();
  
  // Load texture with absolute path from public folder
  // Path must start with / to reference public folder in React
  const texture = useTexture(backgroundImage);
  
  return (
    <>
      <OrbitControls enablePan={false} enableZoom={false} enableRotate={false} />
      <Avatar 
        avatarId={props.avatar_Id}
        position={[0, -4, 5]} 
        scale={2.5} 
        speechMarks={props.speechMarks}
        isCrying={props.isCrying}
      />
      <Environment preset="sunset" />
      <mesh>
        <planeGeometry args={[viewport.width, viewport.height]} />
        <meshBasicMaterial map={texture} />
      </mesh>
    </>
  );
};
